module.exports = __webpack_public_path__ + "img/imagePlaceholder.47d44f48.svg";